import { useContext } from 'react';

import { DataContext } from './data-context';

export const useDataContext = () => useContext(DataContext);
